<template>
  <div class="card">
    <div class="body" v-if="view == 1">
      <div class="body planned_task">
        <div class="dd" data-plugin="nestable">
          <div class="header">
            <h2><strong>등록된 트리거 </strong></h2>
            <div class="header-dropdown">
              <button
                class="btn btn-primary"
                type="button"
                @click="toTriggerNew"
              >
                추가
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover" style="text-align: center">
              <thead>
              <th>#</th>
              <th>키</th>
              <th>라벨</th>
              <th>&nbsp;</th>
              </thead>
              <tbody>
              <tr v-for="(trig, index) in trigList" :key="index">
                <td>{{ index + 1 }}</td>
                <td @click="toTriggerSettingPage(index)">
                  {{ trig.apiKey }}
                </td>
                <td @click="toTriggerSettingPage(index)">
                  {{ trig.apiName }}
                </td>
                <td>
                  <a
                    href="javascript:void(0);"
                    @click="toTriggerSettingPage(index)"
                  >수정</a
                  >
                  &nbsp;&nbsp;&nbsp;
                  <a href="javascript:void(0);" @click="deleteTrigger(index)"
                  >삭제</a
                  >
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="body" v-if="view == 0">
      <div class="body planned_task">
        <div class="dd" data-plugin="nestable">
          <h5>트리거 추가하기</h5>
          <p>
            트리거는 워크플로우를 시작할 때 API에서 데이터를 가지고 오거나 읽을
            수 있게 해줍니다.
          </p>
          <div>
            <button class="btn btn-primary" type="button" @click="toTriggerNew">
              추가
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  name: 'DevelopAppTriggerPage',
  components: {
  },
  data() {
    return {
      view: 0,
      trigList: [],
    }
  },
  methods: {
    toTriggerSettingPage(index) {
      var name = this.trigList[index].apiName;
      this.$store.state.devStore.title = name;
      this.$store.state.devStore.apiCode = this.trigList[index].apiCode;
      this.$store.state.devStore.apiData = this.trigList[index];
      this.$router.push({
        name: "DevTrigSetting",
        params: { appId: this.$route.params.appId, trigName: name },
      });
    },
    toTriggerNew() {
      this.$store.state.devStore.title = "__new__";
      this.$store.state.devStore.apiCode = null;
      this.$router.push({
        name: "DevTrigSetting",
        params: { appId: this.$route.params.appId, trigName: "__new__" },
      });
    },
    deleteTrigger(index) {
      if (confirm("정말 삭제하시겠습니까?")) {
        var param = {
          appCode: this.$store.state.devStore.appCode,
          apiCode: this.trigList[index].apiCode,
        };

        this.api.deleteApi(param)
          .then(() => {
            alert("삭제되었습니다.");

            eventbus.$emit("menuReset");
          })
          .catch(() => alert("오류가 발생했습니다."));
      }
    },
  },
  created() {
    console.log('DevelopAppTriggerPage created')
    eventbus.$on("menuSetted", () => {
      this.trigList = this.$store.state.devStore.apiTrig;
    });

    if (this.$store.state.devStore.apiTrig.length != 0) {
      this.trigList = this.$store.state.devStore.apiTrig;
      this.view = 1;
    }
  },
  mounted() {
    console.log('DevelopAppTriggerPage created')
  },
  beforeDestroy() {
    console.log('DevelopAppTriggerPage beforeDestroy')
  }
}
</script>

